// @flow

/**
 * Joins strings using commas and places "and" in front of the last item.
 *
 * For example:
 * - given ['a'], returns 'a'
 * - given ['a', 'b'], returns 'a and b'
 * - given ['a', 'b', 'c'], returns 'a, b and c'
 */
const listInSeries = (items: any[]): string =>
  items
    .map((item, index, list) => {
      if (index === 0) {
        // Coerce to string
        return `${item}`;
      }
      if (index === list.length - 1) {
        // Oxford comma - https://en.wikipedia.org/wiki/Serial_comma
        if (list.length > 2) {
          return `, and ${item}`;
        }
        return ` and ${item}`;
      }
      return `, ${item}`;
    })
    .join('');

export default listInSeries;
